import { render, staticRenderFns } from "./additionalInformation.vue?vue&type=template&id=4a87298d&scoped=true&"
import script from "./additionalInformation.vue?vue&type=script&lang=js&"
export * from "./additionalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a87298d",
  null
  
)

export default component.exports